/** Paleta de acento del módulo Analytics ODF (teal + apoyos). */
export const TEAL = '#14b8a6'
export const AZUL = '#3b82f6'
export const VERDE = '#22c55e'
export const MORADO = '#a855f7'
export const ROSA = '#ec4899'
export const AMARILLO = '#eab308'

interface KpiCardProps {
  icon: React.ElementType
  label: string
  value: React.ReactNode
  sub: string
  color: string
}

export function KpiCard({ icon: Icon, label, value, sub, color }: KpiCardProps) {
  return (
    <div
      className="rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden"
      style={{ background: `linear-gradient(135deg, ${color}22 0%, ${color}08 50%, transparent 100%)` }}
    >
      <div className="px-5 py-5">
        <div className="flex items-center justify-between mb-4">
          <p className="text-[11px] font-semibold text-muted-foreground uppercase tracking-widest">{label}</p>
          <div
            className="h-9 w-9 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${color}18` }}
          >
            <Icon className="h-5 w-5" style={{ color }} />
          </div>
        </div>
        <div className="text-3xl font-bold text-foreground leading-none mb-1.5">{value}</div>
        <p className="text-xs text-muted-foreground">{sub}</p>
      </div>
      <div className="h-1 w-full" style={{ background: `linear-gradient(to right, ${color}, ${color}40)` }} />
    </div>
  )
}
